/**
 * What the checkout will send a customer to. The provider URL comes from our
 * own API, but it is still the one value that decides where a card number gets
 * typed, so it is checked before any popup, link or frame is pointed at it.
 */

/** Providers that permit framing. Every other provider page opens as a popup. */
export const PROVIDER_FRAME_ORIGINS: readonly string[] = ['https://buy.moonpay.com', 'https://buy-sandbox.moonpay.com'];

const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1']);

/**
 * https only, except loopback http in sandbox; and the simulated provider page
 * (`/payments/mock-…`) is refused outright outside sandbox, so a misconfigured
 * live API can never show a customer the "Approve payment" mock.
 */
export function isAllowedProviderUrl(raw: string, testMode: boolean): boolean {
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return false;
  }
  if (url.username || url.password) return false;
  const schemeOk =
    url.protocol === 'https:' || (testMode && url.protocol === 'http:' && LOOPBACK_HOSTS.has(url.hostname));
  if (!schemeOk) return false;
  return testMode || !url.pathname.includes('/payments/mock-');
}

export function canFrameProvider(raw: string): boolean {
  try {
    return PROVIDER_FRAME_ORIGINS.includes(new URL(raw).origin);
  } catch {
    return false;
  }
}
